import React, {Component} from 'react';
import {Redirect} from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import Button from '@material-ui/core/Button';
import {PostData} from '../../Services/PostData';
import SuccessMessage from '../../components/AlertMessages/SuccessMsg'


const styles = theme => ({
  button: {
    margin: theme.spacing.unit,
  },
  input: {
    display: 'none',
  },
});


class Signup extends Component {

constructor(){
  
  super();

  this.state={ username:'', password:'', alert_message: '', fireRedirect: false}

  }
    handleChange = event =>{
    this.setState({ [event.target.name]:event.target.value })
  }


handleSubmit = event =>{
  event.preventDefault();
  this.setState({ fireRedirect: true })
  console.log("User name : " + this.state.username)
  console.log("User Password : " + this.state.password)
  
  const form = {username:this.state.username, password:this.state.password}
  const formBody = Object.keys(form).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(form[key])).join('&');
  const url ="https://connect-back-end.scottguo.com/auth/register"
fetch(url, { method: 'POST', mode: 'no-cors',
  body: formBody, 
  headers:{ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/x-www-form-urlencoded' } })
    //.then(res => res.json())
    .catch(error => console.error('Error:', error))
    .then(response => console.log('Success:', response)); }



render(){

  const { from } = this.props.location.state || '/'

  const { fireRedirect } = this.state

return(
   <div style={{
            padding: '15px 50px 75px',
            width: '350px',
            margin: 'auto',
          }}>
    <div>
        <MuiThemeProvider>
        <h2>SIGNUP TO CONNECT</h2>
          <form onSubmit={this.handleSubmit}>
            <div>
             <TextField
               hintText="Enter your Username"
               floatingLabelText="Username"
               onChange = {(event,newValue) => this.setState({username:newValue})}
               />
             <br/>
               <TextField
                 type="password"
                 hintText="Enter your Password"
                 floatingLabelText="Password"
                 onChange = {(event,newValue) => this.setState({password:newValue})}
                 />
               <br/>
                <Button
                  type="submit"
                  variant="raised"
                  color="primary">
                  Signup
                </Button>
                <p>Have account?<a href="/login"> Login here</a></p>
            </div>
          </form>
          {fireRedirect && (
          <Redirect to={from || '/login'}/>

          )}
         </MuiThemeProvider>
      </div>

  </div>
  )
  }

}

const style = {
 margin: 15,
};

export default Signup;


// WEBPACK FOOTER //
// ./src/components/Signup/Signup.js